import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchCategory } from '../../../action/categoryAction'
import { updateCategory } from '../../../action/categoryAction'

// One row of the product listing : product photo | contents/pack shot | details.
// The contents shot is optional - a product whose '<image>-contents.png' is missing
// drops that column (onError) instead of rendering a broken image, and the details
// column widens to take the space.
class ProductCard extends Component {
    constructor(props){
        super(props)
        this.state = {showContents:true}
        this.hideContents = this.hideContents.bind(this)
    }

    hideContents(){
        this.setState({showContents:false})
    }

    render(){
        var e = this.props.product;
        var showContents = this.state.showContents && e.ContentImg && e.ContentImg.link;
        var price = e.IsPirce === true
            ? (e.Maxprice === e.Minprice ? "₹"+e.Minprice : "₹"+e.Maxprice+" - ₹"+e.Minprice)
            : e.Minprice;

        return (
            <a href={e.productLink} alttxt={e.Name} className="prod-card-link">
                <div className="card prod-card">
                    <div className="row no-gutters align-items-center">
                        <div className={showContents ? "col-6 col-md-3" : "col-12 col-md-3"}>
                            <div className="prod-card-img">
                                <img src={e.PrimImg.link} alt={e.PrimImg.alttxt}/>
                            </div>
                        </div>
                        {showContents &&
                            <div className="col-6 col-md-4">
                                <div className="prod-card-img prod-card-img-contents">
                                    <img src={e.ContentImg.link} alt={e.ContentImg.alttxt} onError={this.hideContents}/>
                                </div>
                            </div>
                        }
                        <div className={showContents ? "col-12 col-md-5" : "col-12 col-md-9"}>
                            <div className="prod-card-body">
                                <h5 className="prod-card-name">{e.Name}</h5>
                                <div className="prod-card-price">{price}</div>
                                <div className="prod-card-desc"><span dangerouslySetInnerHTML={{ __html: e.Desc }}/></div>
                                <span className="prod-card-cta">View details</span>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        )
    }
}

class Categorypage extends Component {
    constructor(){
        super()
        this.state={
            CategoryName:'Products',
            ProductCount:8,
            Products:[
                {
                    index:1,
                    Name:'',
                    PrimImg:{
                        link:'',
                        alttxt:''
                    },
                    skuImg:[
                        {

                        },

                    ],
                    Maxprice:0,
                    Minprice:0,
                    Marketinglabel:'',
                    productLink:''
                }
            ]
        }
        this.onClick = this.onClick.bind(this);
        this.onUpdatePage = this.onUpdatePage.bind(this);
    }

    onClick(e){
        this.setState({'sort':e.target.value})
        console.log('==> '+ e.target.value)
    }

    onUpdatePage(e){
        e.preventDefault();
        let path = e.target.parentElement.getAttribute('href');
        this.props.updateCategory(path, this.props.history);
    }


    componentDidMount = ()=> {
        this._asyncRequest = fetchCategory(this.props.location).then(
            externalData => {
              this._asyncRequest = null;
              console.log(externalData.data)
              this.setState(externalData.data);
            }
          );
    }

    componentWillUnmount() {
        if (this._asyncRequest) {
          this._asyncRequest.cancel();
        }
    }

    componentWillReceiveProps = nextProps => {
        this.setState(nextProps.cat);
    }


    render() {
        return (
            <div>
                <div className="row justify-content-md-center">
                    <div className="col col-lg-10">
                        <br />
                        <h1 style={{textTransform: "capitalize"}}>products</h1>
                        <br />
                    </div>
                </div>
                <div className="row justify-content-md-center" style={{paddingBottom:'5px'}}>
                    <div className="col col-lg-10" style={{textAlign:"left"}}>
                       {/*} {this.state.ProductCount} products found. }*/}
                    </div>
                    <div className="col col-lg-3" style={{textAlign:"right"}}>

                    </div>
                </div>
                    {[...this.state.Products].sort((a,b)=>a.index-b.index).map((e,i)=>{
                        return <div className="row justify-content-center" key={e.id || i}>
                            <div className="col col-lg-10 col-12">
                                <ProductCard product={e}/>
                            </div>
                        </div>
                    })}
            </div>
        )
    }
}

function mapStateToProps(state){
    return {cat:state.cat};
}

export default withRouter(connect(mapStateToProps, {updateCategory})(Categorypage));
